<template>
    <div class="tweet-card-container">
        <div class="tweet-card">
            <div>
                <div class="tweet-card-header">
                    <div>
                        <h5>{{$t('str.ComposeNewTweet')}}</h5>
                        <i class="fa fa-times" v-on:click="close"></i>
                    </div>
                </div>
                <div class="tweet-card-slide">
                    <div>
                        <img :src="slideUrl">
                    </div>
                </div>
                <div class="tweet-card-comment">
                    <div>
                        <textarea name="user-text" v-model="message" maxlength="280" :placeholder="$t('str.WhatIsHappening')"></textarea>
                    </div>
                </div>
                <div class="tweet-card-footer">
                    <div>
                        <label>{{message.length}} / 280</label>
                        <a v-on:click="tweetSlide">{{$t('str.TWEET')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

// TODO: add checks to see if tweet properly sent
import {LeadBus} from '../router/index';
import {EventBus} from '../router/index';
import CookieUtils from '../javascript-classes/utils/storage.js';

export default {

    props: {
        twitterProfile: {},
        currentSlide: '',
        slideList: {},
        user: {},
        socialMedia: {}
    },

    data () {
        return {
            userText: undefined
        };
    },

    computed: {
        slideUrl() {
            return this.slideList && this.currentSlide !== undefined && this.slideList[this.currentSlide] ? this.slideList[this.currentSlide].url : undefined;
        },

        message: {
            get() {
                if (this.userText !== undefined) {
                    return this.userText;
                }

                if (this.socialMedia && this.socialMedia.Twitter) {
                    return this.socialMedia.Twitter;
                }

                return '';
            },

            set(newMessage) {
                this.userText = newMessage;
            }
        }
    },

    methods: {
        close() {
            this.$emit('closeTweetUI'); 
        },

        tweetSlide() {
            EventBus.$emit('tweetSlide', {
                url: this.slideList[this.currentSlide].url,
                id: this.slideList[this.currentSlide].id,
                nativeSlideId: this.slideList[this.currentSlide].slideId,
                status: this.message === '' ? this.$t('str.CheckOutTheSlideFromSessionIAmAttendingDialogloop') : this.message
            }, (err) => {
                if (err) {
                    return;
                }

                // Save the fact we sent a tweet
                let key = this.user.id + "_tweets";
                let tweets = CookieUtils.getItem(key, "{}");

                try {
                    tweets = JSON.parse(tweets);
                    tweets[this.slideList[this.currentSlide].id] = true;
                    CookieUtils.setItem(key, tweets);
                } catch(e) {
                    console.log(e);
                    return;
                }

                // TODO: send notification that tweet was succesfully sent
                // close tweet UI
                this.$emit('closeTweetUI');  
                LeadBus.$emit('recordLead', {
                    type: 'shared-on',
                    data: {
                        sharedon: 'twitter',
                        onSlideId: this.currentSlide
                    }
                });
            });
        }
    }
};

</script>

<style lang="scss">

.tweet-card-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.tweet-card {
    width: 260px;
    height: 400px;
    box-sizing: border-box;
    position: relative;
    z-index: 5000;
    margin: 0 auto;
    padding: 10px;
    background-color: #fff;
    border-radius: 0px;
    border: 9px solid rgba(0,0,0,0.25);
    overflow: hidden;
    box-shadow: none;
    display: block;
    text-decoration: none;
    font-family: "Poppins", sans-serif;
    font-size: 1rem;
    font-weight: normal;
    line-height: 1.5;

    & > div {
        display: table;
        width: 100%;
        height: 100%;
    }

    & > div > div {
        display: table-row;
        width: 100%;
        height: 1px;
    }

    .tweet-card-header > div {
        padding: 0 0 16px 0;
        position: relative;

        h5 {
            font-weight: 600;
            white-space: pre-wrap;
            color: #333;
            margin: 0;
            padding: 0 28px;
            text-align: center;

            -webkit-user-select: none;
            -khtml-user-select: none;
            -webkit-touch-callout : none;
            -moz-user-select: none;
            -o-user-select: none;
            user-select: none;
        }

        i {
            position: absolute;
            right: 4px;
            top: 1px;
            color: #d4451d;
            cursor: pointer;
        }
    }

    .tweet-card-slide > div {
        border: 1px solid #ddd;

        img {
            width: 100%;
        }
    }

    .tweet-card-comment {
        height: 100%;

        & > div {
            padding: 10px 0;
            height: 100%;
        }

        textarea {
            border: 1px solid #ddd;
            width: 100%;
            height: 100%;
            resize: none;
            overflow-y: auto;
            border-radius: 0;
            box-sizing: border-box;
            outline: none;
            font-size: 1rem;
        }
    }

    .tweet-card-footer > div {
        font-size: .8em;
        padding: 10px 0 0 0;

        label {
            color: #9e9e9e;
        }

        a {
            color: #d4451d;
            float: right !important;
            cursor: pointer;
        }
    }
}

</style>



// WEBPACK FOOTER //
// TweetSlideUI.vue?c8d5ef44